var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "title typographies-heading-h2" }, [
      _vm._v(_vm._s(_vm.$l10n.__("Paramètres de l’import")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "subtitle typographies-paragraph-medium-regular" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "Cette section vous permet de déterminer les actions que nous allons effectuer lors du traitement de l’import."
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "option-type-container" },
      _vm._l(_vm.parameters, function(optionType, key) {
        return _c("div", { key: key }, [
          _c(
            "h3",
            { staticClass: "typographies-heading-h3 option-type-title" },
            [_vm._v(_vm._s(optionType.title))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "parameter-container" },
            _vm._l(optionType.options, function(parameter, parameterKey) {
              return _c(
                "div",
                { key: parameterKey, staticClass: "parameter-item" },
                [
                  parameter.title
                    ? _c(
                        "div",
                        { staticClass: "parameter-title" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "typographies-paragraph-medium-semibold"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(parameter.title) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "CompassTooltip",
                            {
                              attrs: {
                                contentClass: "tooltip-import-options",
                                placement: "bottom-start"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "content",
                                    fn: function() {
                                      return _vm._l(parameter.values, function(
                                        choice
                                      ) {
                                        return _c(
                                          "div",
                                          { key: choice.value },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "typographies-heading-h4"
                                              },
                                              [_vm._v(_vm._s(choice.label))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "typographies-paragraph-small-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(choice.description) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("CompassIcon", {
                                attrs: {
                                  icon: "info-circle-fill",
                                  size: "small"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "CompassSelect",
                    {
                      attrs: { menuClass: "menu-import-dialog" },
                      model: {
                        value: _vm.getOptionsSelectedImport[parameterKey],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.getOptionsSelectedImport,
                            parameterKey,
                            $$v
                          )
                        },
                        expression: "getOptionsSelectedImport[parameterKey]"
                      }
                    },
                    _vm._l(parameter.values, function(option) {
                      return _c(
                        "CompassDropdownSelectOption",
                        _vm._b(
                          { key: option.value },
                          "CompassDropdownSelectOption",
                          option,
                          false
                        )
                      )
                    }),
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }